import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import { SERVICE_HOME_SECURE } from '../constants'
import ThingsToKnow from './ThingsToKnow'
import SubHeader from '../components/SubHeader'
import HomeSecureSubscribeForm from '../forms/HomeSecureSubscribeForm'
import PaymentInformation from './PaymentInformation'
import globals from '../globals'
import CustomLink from '../components/CustomLink'
import Button from '../elements/Button'

const HomeSecureSubscribeModule = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [homeSecureServices, setHomeSecureServices] = useState([])

    useEffect(() => {
        DataSource.getData('/api/getHomeSecureServices', response => {
            setIsLoaded(true)
            setHomeSecureServices(response.homeSecureServices)
        }, () => {
            setHasError(true)
            setIsLoaded(true)
        })
    }, [])

    const handleSuccess = () => {
        globals.pushEvent('HsSubscriptionStart')
    }

    const setSuccessMsg = (response, values) => {
        return <div className='text-center'>Great! You have successfully subscribed to Home Secure.<br /><br /><Button title='Take me there' href={`/my-services/home-secure/${values.serviceId}`} /></div>
    }

    return (
        <div>
            {/* Below divs are for scrolling animation on submit */}
            <div id='sub-navigation' />
            <div id='sub-navigation-mobile' />
            <div className='module' style={{ overflow: 'visible' }}>
                <Heading title='Subscribe to Home Secure' />
                <ModuleWithLoader isLoaded={isLoaded} hasError={hasError} className='p-4'>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2 text-center'>
                            <SubHeader
                                content='Because Home Secure works at the level of your internet connection, it helps protect every device connected to your Exetel home internet or WiFi. You can quickly and easily set or adjust your content and security settings to help block inappropriate content and malicious sites that seek to steal your personal data or defraud you.'
                                className='mb-3'
                            />
                        </div>
                        <div className='col-12'>
                            <HomeSecureSubscribeForm
                                homeSecureServices={homeSecureServices}
                                serviceId={props.serviceId}
                                handleSuccess={handleSuccess}
                                setSuccessMsg={setSuccessMsg}
                            />
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
            {homeSecureServices.length > 0
                ? <React.Fragment>
                    <ThingsToKnow type={SERVICE_HOME_SECURE} />
                    <PaymentInformation />
                  </React.Fragment>
                : ''}
        </div>
    )
}

HomeSecureSubscribeModule.propTypes = {
    serviceId: PropTypes.number
}

export default HomeSecureSubscribeModule



// WEBPACK FOOTER //
// ./resources/js/modules/HomeSecureSubscribeModule.js